import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUnauthorizedHandler } from '../utils/makeRequest';

const useAutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      navigate('/login');
    };
    registerUnauthorizedHandler(handleUnauthorized);
    return () => registerUnauthorizedHandler(null);
  }, [navigate]);
};

export default useAutoLogout; 